
/* Library */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import commonUtil from './../../../../utils/commonUtil';
// import { constAPISuccess } from '../../../../utils/clientConstant';

// import components
import Warning from '../../../../components/Warning';
import EventOwner from './components/EventOwnerData';
import ApplyCSS from '../../../../components/ApplyCSS';
import EventWizard from './../EventWizard';

// Actions
import * as createEventObject from '../../../createEvent/actions';
import * as typeActions from './actions';
import { createTag } from '../../../../utils/googleTagManagerUtils';
import { eventType } from '../../../../utils/clientConstant';
import EventOwnerDataTop from './components/EventOwnerDateTop';
import EventCoOwnerType1 from './components/EventCoOwnerType1';
import _ from 'lodash';

const { defineCreateEventData, captureCelebrityTitle } = createEventObject;
const { loadGiftRegistryCelebrated } = typeActions;
const channel = commonUtil.getChannel();

const errorObject = require('../../../../utils/errors/LP_GR_error.json');

@connect(store => ({
  lables: store.labels.data,
  user: store.user.data,
  error: store.labels.error,
  loading: store.labels.loading,
  extraData: store.labels.extraData,
  eventCategoryType: store.eventcategory.data,
  createEventObject: store.createEventObject,
}),
  { ...createEventObject, ...typeActions })

class GiftRegistryCelebrated extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValid: false,
      titleValue : '',
      emailError: '',
      emailErrorCelebrity: ''
    };
    this.validateFirstForm = false;
    this.config = this.props.createEventObject && this.props.createEventObject.SelectTypeCelebration && this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration ? this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration : null;
    this.coOwnerComponent = this.config && this.config.coOwnerComponent ? this.config.coOwnerComponent : null;
    this.currentEvent = this.config && this.config.name ? this.config.name : null;
    this.coOwnerOptional = this.config && this.config.coownerOptional ? this.config.coownerOptional : null;
    this.assignRole = this.config && this.config.assignRole ? this.config.assignRole : null;
    this.currentIndex = this.config && this.config.components[0] && this.config.components[0].step ? this.config.components[0].step : null;
    this.eventDetail = this.props.eventCategoryType && this.props.eventCategoryType.eventConfigurations ? this.props.eventCategoryType.eventConfigurations.filter(item => item.name === this.currentEvent)[0] : null;
    this.selectMesaType = this.props.createEventObject && this.props.createEventObject.SelectMesaType ? this.props.createEventObject.SelectMesaType : null;
    this.isPermit = false;
    this.warningMessage = null;
    this.oldOwnerTitle = null;
    this.focusField = '';
    this.hideOwnerForm= false;

    this.validate = this.validate.bind(this);
    this.ownerRoleSelected = this.ownerRoleSelected.bind(this);
    this.setFocusField = this.setFocusField.bind(this);
    this.festejado2Ref = React.createRef();
  }
  componentDidMount() {
    this.props.onReference(this);
    if (document) {
      document.querySelector('.mainContainer').classList.add(this.props.animationClass);
    }
    commonUtil.goToTop();
  }

  setFocusField(fieldId) {
    if (!this.focusField) {
      this.focusField = fieldId;
      if (fieldId === 'title') {
        commonUtil.goToTop();
      }
      document.getElementById(fieldId).focus();
    }
  }

  updateFormValidity = () => {
  // Get data from the forms
  const ownerData = this._festejado1?.getformData() || {};
  const coOwnerData = this.festejado2Ref?.current?.getformData() || {};
  const thirdData = this._festejado3?.getformData?.() || {};

  // Helper to check if required fields are filled
  const isOwnerFilled = !!(ownerData.firstName && ownerData.lastName);
  const isCoOwnerFilled = !!(coOwnerData.firstName && coOwnerData.lastName);

  // For third form, check only if event is not 'Boda'
  let isThirdFilled = true;
  if (this.currentEvent !== eventType.Boda) {
    isThirdFilled = !!(thirdData.firstName || thirdData.titleCelebrity);
  }

  // Combine all checks
  const isFormValid = isOwnerFilled && isCoOwnerFilled && isThirdFilled;

  // Update state
  this.setState({ isFormValid });
}

  validateFormData = () => {
    this.focusField = '';
    const firstFormData = this._festejado1?.handleformValidate();
    const secondFormData = this.festejado2Ref?.current?.handleformValidate();
    const firstFormDataEmail = this._festejado1?.formData?.userData?.email ?? '';
    const secondFormDataEmail = this.festejado2Ref?.current?.formData?.userData?.email ?? '';

    if (firstFormDataEmail && secondFormDataEmail) {
      let emailValid = commonUtil.compareEmail(secondFormDataEmail,firstFormDataEmail);
      if (!emailValid) {
        this.setState({
          emailError: commonUtil.getLabel(errorObject.CreateEventStep1, 'CreateEventStep1.emailMatch.error2')
        });

        return false;
      }
    }


    if(secondFormData) {
      this.setState({ emailError: ''});
    }
    let thirdFormData = true;
    if (this.currentEvent !== eventType.Boda) {
      thirdFormData = this._festejado3?.handleformValidate();
    }
    if(thirdFormData) {
      this.setState({ emailErrorCelebrity: ''});
    }
    const isValidForm = firstFormData && secondFormData && thirdFormData;
    if (isValidForm) {
      return true;
    }
    return false;
  }
  
   emptyEmailError = () => {
    this.setState({ emailError: ''});
   }
  
  setEmailErrorCelebrity = (value) => {
   this.setState({ emailErrorCelebrity: value});
  }

  validate(validationCallBack) {
    const {lables} = this.props;
    this.focusField = '';
    const firstFormData = this._festejado1.handleformValidate();
    const secondFormData = this.festejado2Ref?.current?.handleformValidate();
    // const firstFormDataEmail = this._festejado1?.formData?.userData?.email ?? '';
    // const secondFormDataEmail = this.festejado2Ref?.current?.txtEmail?.getValue() ?? '';

    // if (firstFormDataEmail && secondFormDataEmail) {
    //   let emailValid = commonUtil.compareEmail(secondFormDataEmail,firstFormDataEmail);
    //   if (!emailValid) {
    //     isEmailError = true;
    //   }
    // }

    let thirdFormData = true;
    if (this.currentEvent !== eventType.Boda) {
      thirdFormData = this._festejado3?.handleformValidate();
    }
    const isValidForm = firstFormData && secondFormData && thirdFormData;
    const dataToSave = [];
    const emailId = this.festejado2Ref?.current?.getformData().email;
    const celebrityEmail = this._festejado3?.getformData().emailXvAnos;
    const warningRef = this.warning;
    const createTagOnSuccess = () => createTag({
      event: 'mesa_regalos',
      phase: 'Crear mesa de regalos',
      step: 'Datos del festejado',
      selection: `${this.props.createEventObject.SelectMesaType}|${this.props.createEventObject.SelectTypeCelebration.selectedEventConfiguration.name}`,
      seccion: 'Mesa de Regalos',
    });
    let emailErrorCoOwner = '';
    let profileIdCoOwner = ''
    if (emailId && isValidForm) {
      loadGiftRegistryCelebrated(emailId, this.currentEvent).then((response) => {
        if (response.body && response.body.status && response.body.status.status === 'failure') {
          warningRef.setMessage(response.body.status.errorMessage);
          validationCallBack(false);
          return false;
        } else if (isValidForm) {
          if(!celebrityEmail){
            dataToSave.push(this._festejado1.getformData());
          }
          let coOwnerData = this.festejado2Ref?.current?.getformData();
          let ownerData={}
          coOwnerData.profileId = response?.body?.profileId;
          profileIdCoOwner = response?.body?.profileId;
          if (this.currentEvent !== eventType.Boda) {
           ownerData = this._festejado3.getformData();
          }
          if (((coOwnerData.firstName && coOwnerData.lastName) || (coOwnerData.title === "Si" && this.currentEvent !== eventType.Boda)) && (coOwnerData.title !== 'No')) {
            if(!celebrityEmail){
              dataToSave.push(coOwnerData);
            }
          }
          if(!_.isEmpty(ownerData.titleCelebrity)){
            this.props.captureCelebrityTitle(ownerData.titleCelebrity);
          }
          if (this.currentEvent !== eventType.Boda && ownerData.firstName && ownerData.titleCelebrity !== "Yo soy el festejado" && !celebrityEmail) {
            dataToSave.push(ownerData);
          }
          // const { getCoOwnerProfileId } = this.props;
          // getCoOwnerProfileId(emailId);
          if(!celebrityEmail){
            const { defineCreateEventData } = this.props; // eslint-disable-line no-shadow
            defineCreateEventData(this.currentIndex, { data: dataToSave });
          }
        }
        if(!celebrityEmail){
          validationCallBack(true);
          createTagOnSuccess();
        }
      }).catch((error) => {
        // this.warning.setMessage(error?.body?.detail);
        
        this.setState({ emailError: error?.body?.detail ? error?.body?.detail : commonUtil.getLabel(lables.createEventStep1, error.body.title) , formValid: false});
        //emailErrorCoOwner = error?.body?.detail && commonUtil.getLabel(lables.createEventStep1, error.body.title) || error?.body?.detail;
        emailErrorCoOwner = error?.body?.detail;
        console.error('Error in loadGiftRegistryCelebrated:', error);
        throw error;
      })
      if(!celebrityEmail){
        return true;
      }
    }if (celebrityEmail && isValidForm) {
      loadGiftRegistryCelebrated(celebrityEmail, this.currentEvent).then((response) => {
        if (response.body && response.body.status && response.body.status.status === 'failure') {
          warningRef.setMessage(response.body.status.errorMessage);
          validationCallBack(false);
          return false;
        } else if (isValidForm) {
          dataToSave.push(this._festejado1.getformData());
          let coOwnerData = this.festejado2Ref?.current?.getformData();
          if(profileIdCoOwner){
            coOwnerData.profileId = profileIdCoOwner;
          }
          let ownerData={}
          ownerData.profileId = response?.body?.profileId;
          ownerData.hasPermission = true;

          if (this.currentEvent !== eventType.Boda) {
            const festejado3Data = this._festejado3.getformData();
            ownerData = {...ownerData, ...festejado3Data};
          }
          if (((coOwnerData.firstName && coOwnerData.lastName) || (coOwnerData.title === "Si" && this.currentEvent !== eventType.Boda)) && (coOwnerData.title !== 'No')) {
            dataToSave.push(coOwnerData);
          }
          if (this.currentEvent !== eventType.Boda && ownerData.firstName && ownerData.titleCelebrity !== "Yo soy el festejado") {
            dataToSave.push(ownerData);
          }
          const { defineCreateEventData } = this.props; // eslint-disable-line no-shadow
          defineCreateEventData(this.currentIndex, { data: dataToSave });
        }
        validationCallBack(true);
        createTagOnSuccess();
        if(!emailErrorCoOwner){
          return true;
        }
      }).catch((error) => {
        this.setState({ emailErrorCelebrity: error?.body?.detail && commonUtil.getLabel(lables.createEventStep1, error.body.title) || error?.body?.detail, formValid: false});
        console.error('Error in loadGiftRegistryCelebrated:', error);
        throw error;
      })
    }else if (isValidForm) {
      dataToSave.push(this._festejado1.getformData());
      const coOwnerData = this.festejado2Ref?.current?.getformData();
      let ownerData={}

      if (this.currentEvent !== eventType.Boda) {
        ownerData = this._festejado3.getformData();
      }
      
      if (((coOwnerData.firstName && coOwnerData.lastName) || (coOwnerData.title === "Si" && this.currentEvent !== eventType.Boda)) && (coOwnerData.title !== 'No')) {
        dataToSave.push(coOwnerData);
      }
      if(!_.isEmpty(ownerData.titleCelebrity)){
        this.props.captureCelebrityTitle(ownerData.titleCelebrity);
      }
      if (this.currentEvent !== eventType.Boda  && ownerData.firstName && ownerData.titleCelebrity !== "Yo soy el festejado") {
        dataToSave.push(ownerData);
      }
      const { defineCreateEventData } = this.props; // eslint-disable-line no-shadow
      defineCreateEventData(this.currentIndex, { data: dataToSave });
      if (!this.isPermit) {
        validationCallBack(true);
        createTagOnSuccess();
        return true;
      }
      validationCallBack(true);
      createTagOnSuccess();
      return true;
    }
    validationCallBack(false);
    return false;
  }

  _getHeaderGreetingTitleByEventType = (eventName) => {
    const {lables} = this.props
       
    switch (eventName) {
      case 'Boda':
        return commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.bodaHeading.label');
          
      case 'Cumpleaños':
        return  commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.birthdayHeading.label');
          
      case 'Bebé':
        return commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.babyHeading.label');
         
      case 'Bautizo':
        return commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.baptismHeading.label');
      case 'Mascotas':
        return commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.mascatosHeading.label');
         
      case 'Otros':
      case 'Otras Ceremonias Religiosas':
        return commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.otherHeading.label');
      case 'Open House':
        return commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.openhouseHeading.label');
          
      case 'XV años':
        return commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.xvanosHeading.label');
          
    
    }
    return `no event name found`; 
   }

  getFormHeadingLabelByEventType = (eventName, side) => {
    const { lables } = this.props;

    if (!['left', 'right'].includes(side)) {
        return `invalid side provided`;
    }

    switch (eventName) {
        case 'Boda':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.boda.${side}.formHeading.label`);

        case 'Cumpleaños':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.birthday.${side}.formHeading.label`);

        case 'Bebé':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.baby.${side}.formHeading.label`);

        case 'Bautizo':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.baptism.${side}.formHeading.label`);

        case 'Mascotas':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.mascotas.${side}.formHeading.label`);

        case 'Otros':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.other.${side}.formHeading.label`);

        case 'Otras Ceremonias Religiosas':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.otherReligiousCeremonies.${side}.formHeading.label`);

        case 'Open House':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.openhouse.${side}.formHeading.label`);

        case 'XV años':
            return commonUtil.getLabel(lables.createEventStep1, `createEventStep1.xvanos.${side}.formHeading.label`);
    }

    return `no event name found`;
  };

  ownerRoleSelected(selectedTitle) {
    if (selectedTitle.value &&  this.festejado2Ref?.current &&  this.festejado2Ref?.current?.onOwnerRoleSelected) {
      const ownerRole = selectedTitle.value || selectedTitle.value.split(' ')[1];
      let flushRecord = false;
      if (ownerRole !== this.oldOwnerTitle) {
        flushRecord = true;
      }
      this.oldOwnerTitle = ownerRole;
       this.festejado2Ref?.current?.onOwnerRoleSelected(ownerRole, flushRecord);
    }
  }
  toggleDisclaimer = () => {
    if (this.disclaimer) {
      const display = (this.disclaimer && this.disclaimer.style && this.disclaimer.style.display);
      if (display === 'none') {
        this.disclaimer.style.display = 'block';
      } else {
        this.disclaimer.style.display = 'none';
      }
    }
  }
  renderwebdata() {
    const { lables, createEventObject } = this.props; // eslint-disable-line no-shadow
    let userData = '';
    let user = '';
    if (createEventObject && createEventObject[this.currentIndex]) {
      userData = createEventObject[this.currentIndex];
    } else if (this.props.user && this.props.user.result) {
      user = this.props.user.result;
    } else {
      userData = null;
      user = null;
    }
    const currentDate = new Date();
    const startDate = new Date('january 01, 1900');
    const ownerEmail = this.props.user && this.props.user.result && this.props.user.result.emailId ? this.props.user.result.emailId : null;
    
    return (<>
      <div className={'mainContainer register'}>
        <ApplyCSS pageName="GiftRegistryCelebrated" />
        <div id="createCelebrate" className="container">
          <div className="forms_layout_container">
              <div className="col-xs-12 margin-16 forms-layout-header">
              <h1 className="titleSection text-center">
                  {this._getHeaderGreetingTitleByEventType(this.currentEvent)}
                </h1>
              <h2 className="subtitleModule_New">{commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.eventSubHeading.label')}</h2>
            </div>
            
            <div className="row padding_form_container forms-layout-header">
              <div className="col-xs-12 col-md-10 col-md-offset-1">
                <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
              </div>
              <div className="col-xs-12 forms-container-event">
                <form className="registerForm" id="giftRegisgry" >
                  <div className='row equal-height'>
                    {/* Festejado(a) 1 Component */}
                    <div className="col-xs-12 col-sm-6  ownerForm-container">
                     {
                      this.currentEvent !== eventType.Boda &&  <EventOwnerDataTop index="2" eventName={this.currentEvent} ref={(festejado3) => { this._festejado3 = festejado3; }} selectMesaType={this.selectMesaType} lables={this.props.lables} startDate={startDate} currentDate={currentDate} assignRole={this.assignRole} optional={this.coOwnerOptional} userData={userData?.data?.find(item => String(item?.coOwner ?? "").toLowerCase() === "false" && String(item?.celebrity ?? "").toLowerCase() === "true")} user={this.props.user.result} eventDetail={this.eventDetail} onChangeFunc={this.ownerRoleSelected} focusOnError={this.setFocusField} onChange={this.updateFormValidity} isChanged = {userData && userData.data && userData.data.length > 0 ? true : false} emailErrorCelebrity={this.state.emailErrorCelebrity} getFormHeadingLabelByEventType={this.getFormHeadingLabelByEventType} ownerEmailId={ownerEmail} coOwnerEmailId={this.festejado2Ref?.current?.txtEmail?.getValue() ?? ''} setEmailErrorCelebrity={this.setEmailErrorCelebrity}/>
                    }
                      <EventOwner index="0" eventName={this.currentEvent} ref={(festejado1) => { this._festejado1 = festejado1; }} selectMesaType={this.selectMesaType} lables={this.props.lables} startDate={startDate} currentDate={currentDate} assignRole={this.assignRole} optional={this.coOwnerOptional} userData={userData && userData.data[0] ? userData.data[0] : user} user={this.props.user.result} eventDetail={this.eventDetail} onChangeFunc={this.ownerRoleSelected} focusOnError={this.setFocusField} onChange={this.updateFormValidity} getFormHeadingLabelByEventType={this.getFormHeadingLabelByEventType} />
                    </div>
                    {/* Festejado(a) 2 Component */}
                    <div className="col-xs-12 col-sm-6 ownerForm-container">
                      <div className="coOwnerBox">
                        <EventCoOwnerType1
                          index="1"
                          ref={this.festejado2Ref}
                          startDate={startDate}
                          currentDate={currentDate}
                          eventName={this.currentEvent}
                          showMiddleName="true"
                          assignRole={this.assignRole}
                          optional={this.coOwnerOptional}
                          isPermit={this.isPermit}
                          userData={
                            userData?.data?.find(item => 
                                item?.coOwner && item?.coOwner?.includes("true")
                              ) 
                          }
                          eventDetail={this.eventDetail}
                          lables={this.props.lables}
                          ownerTitle={userData && userData.data[0] && userData.data[0].title ? userData.data[0].title : null}
                          toggleDisclaimer={this.toggleDisclaimer}
                          ownerEmailId={ownerEmail}
                          celebrityEmailXvAnos={this._festejado3?.emailXvAnos?.getValue() ?? ''}
                          focusOnError={this.setFocusField}
                          onChange={this.updateFormValidity}
                          isChanged = {userData && userData.data && userData.data.length > 0 ? true : false}
                          emailError={this.state.emailError}
                          getFormHeadingLabelByEventType={this.getFormHeadingLabelByEventType}
                          setEmptyEmailError={this.emptyEmailError}
                        />
                      </div>
                    </div>
                  </div>
                <div className="row">
                  <EventWizard prev={this.props.eventWizardAttributes.prevAttr} next={this.props.eventWizardAttributes.nextAttr} submit={this.props.eventWizardAttributes.submitAttr} currentStep={this.props.currentStep} totalStep={this.props.totalStepsForEvent} isDisabled = {false}/>
                </div>
              </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      </>
    );
  }
  renderwapdata() {
    const { lables, createEventObject } = this.props; // eslint-disable-line no-shadow
    let userData = '';
    let user = '';
    if (createEventObject && createEventObject[this.currentIndex]) {
      userData = createEventObject[this.currentIndex];
    } else if (this.props.user && this.props.user.result) {
      user = this.props.user.result;
    } else {
      userData = null;
      user = null;
    }
    const currentDate = new Date();
    const startDate = new Date('january 01, 1930');
    const ownerEmail = this.props.user && this.props.user.result && this.props.user.result.emailId ? this.props.user.result.emailId : null;
    

    return (
      <div className="mainContainer grayBackground">
        <ApplyCSS pageName="GiftRegistryCelebrated" />
        <div className="container">
          <div className="contentBox" id="multipleAddress">
            <div className="row">
              <div className="col-xs-12">
                <h2 className="titleSectionNew">
                  {/* Hola {this.props.user.result.firstName} ,
                   {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.title.message')} */}
                     {this._getHeaderGreetingTitleByEventType(this.currentEvent)}
                   </h2>
                <p className="informativeTextNew">
                  {/* {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.title1.message')} */}
                  {commonUtil.getLabel(lables.createEventStep1, 'createEventStep1.eventSubHeading.label')}
                  </p>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-12">
                <Warning type="error" text={this.warningMessage} ref={warning => this.warning = warning} />
              </div>
            </div>
            <div className="row">
              <form id="giftRegisgryForm">
                {/* EventCoOwner */}
                <div className="col-xs-12 col-sm-6 col-md-5">
                  {
                    this.currentEvent !== eventType.Boda &&  <EventOwnerDataTop index="2" eventName={this.currentEvent} ref={(festejado3) => { this._festejado3 = festejado3; }} selectMesaType={this.selectMesaType} lables={this.props.lables} startDate={startDate} currentDate={currentDate} assignRole={this.assignRole} optional={this.coOwnerOptional} userData={userData?.data?.find(item => String(item?.coOwner ?? "").toLowerCase() === "false" && String(item?.celebrity ?? "").toLowerCase() === "true")} user={this.props.user.result} eventDetail={this.eventDetail} onChangeFunc={this.ownerRoleSelected} focusOnError={this.setFocusField} onChange={this.updateFormValidity} isChanged = {userData && userData.data && userData.data.length > 0 ? true : false} emailErrorCelebrity={this.state.emailErrorCelebrity} getFormHeadingLabelByEventType={this.getFormHeadingLabelByEventType} ownerEmailId={ownerEmail} />
                  }
                  <EventOwner index="0" eventName={this.currentEvent} ref={(festejado1) => { this._festejado1 = festejado1; }} selectMesaType={this.selectMesaType} lables={this.props.lables} startDate={startDate} currentDate={currentDate} assignRole={this.assignRole} optional={this.coOwnerOptional} userData={userData && userData.data[0] ? userData.data[0] : user} user={this.props.user.result} eventDetail={this.eventDetail} onChangeFunc={this.ownerRoleSelected} focusOnError={this.setFocusField} onChange={this.updateFormValidity} getFormHeadingLabelByEventType={this.getFormHeadingLabelByEventType} />
                </div>
                {/* Festejado(a) 2 Component */}
                <div className="col-xs-12">
                  <div className="coOwnerBox">
                    <EventCoOwnerType1 
                          index="1"
                          ref={this.festejado2Ref}
                          startDate={startDate}
                          currentDate={currentDate}
                          eventName={this.currentEvent}
                          showMiddleName="true"
                          assignRole={this.assignRole}
                          optional={this.coOwnerOptional}
                          isPermit={this.isPermit}
                          userData={
                            userData?.data?.find(item => 
                                item?.coOwner && item?.coOwner?.includes("true")
                              ) 
                          }
                          eventDetail={this.eventDetail}
                          lables={this.props.lables}
                          ownerTitle={userData && userData.data[0] && userData.data[0].title ? userData.data[0].title : null}
                          toggleDisclaimer={this.toggleDisclaimer}
                          ownerEmailId={ownerEmail}
                          focusOnError={this.setFocusField}
                          onChange={this.updateFormValidity}
                          isChanged = {userData && userData.data && userData.data.length > 0 ? true : false}
                          emailError={this.state.emailError}
                          getFormHeadingLabelByEventType={this.getFormHeadingLabelByEventType}
                          setEmptyEmailError={this.emptyEmailError}
                        />
                  </div>
                </div>
                <div className="col-xs-12 col-sm-8 col-md-4 col-md-offset-4">
                  <EventWizard prev={this.props.eventWizardAttributes.prevAttr} next={this.props.eventWizardAttributes.nextAttr} submit={this.props.eventWizardAttributes.submitAttr} currentStep={this.props.currentStep} totalStep={this.props.totalStepsForEvent} isDisabled={false} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
  render() {
    return (
      <React.Fragment>
        <ApplyCSS pageName="GiftRegistryCelebrated" />
        {channel === 'wap' ? this.renderwapdata() : this.renderwebdata()}
      </React.Fragment>
    );
  }

}

const matchDispatchToProps = dispatch => bindActionCreators({ defineCreateEventData, captureCelebrityTitle }, dispatch);

export default connect(matchDispatchToProps)(GiftRegistryCelebrated);
